import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { formatPercent } from '../utils/formatters';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function SectorBreakdown() {
  const [sectors, setSectors] = useState([]);

  useEffect(() => {
    const load = async () => {
      try {
        const { data } = await axios.get(`${API}/stocks/sector-breakdown`, { withCredentials: true });
        setSectors(data);
      } catch {
        setSectors([]);
      }
    };
    load();
  }, []);

  return (
    <div className="bg-[#12141A] border border-white/10 p-6" data-testid="sector-breakdown">
      <h3 className="text-xl font-heading font-bold tracking-tight text-white mb-4">Sector Heat Map</h3>
      <div className="space-y-2">
        {sectors.map((s) => {
          const isPositive = s.avg_change_percent >= 0;
          const barWidth = Math.min(Math.abs(s.avg_change_percent) * 20, 100);
          return (
            <div key={s.sector} className="flex items-center gap-3" data-testid={`sector-${s.sector}`}>
              <div className="w-28 text-xs text-white font-medium truncate">{s.sector}</div>
              <div className="flex-1 relative h-6 bg-white/[0.02] border border-white/5">
                <div
                  className={`absolute top-0 h-full ${isPositive ? 'left-1/2 bg-[#00FF66]/30 border-l-2 border-[#00FF66]' : 'right-1/2 bg-[#FF3366]/30 border-r-2 border-[#FF3366]'}`}
                  style={{ width: `${barWidth / 2}%` }}
                />
                <div className="absolute inset-0 border-l border-white/10" style={{ left: '50%' }} />
              </div>
              <div className={`w-16 text-right font-mono text-xs ${isPositive ? 'text-[#00FF66]' : 'text-[#FF3366]'}`}>
                {formatPercent(s.avg_change_percent)}
              </div>
              <div className="w-8 text-right font-mono text-xs text-[#64748B]">{s.stock_count}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
